import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBase } from '~types/response';

interface Payload extends AuthModel.PasscodeRequest {
  passcode: string;
}

interface Response extends ResponseBase {
  data: {
    email: string;
    passcode: string;
  };
}

/**
 * 비밀번호 변경 시 전달받은 인증코드를 인증
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/password-controller/verifyPasscode
 * @param payload
 * @returns
 */
export default function postPasswordVerifyPassCode(data: Payload) {
  return API.post<Response>('/api/v2/users/password/verify-passcode', { data });
}
